import { render } from "./ZhangGH.vue?vue&type=template&id=1e908c89&scoped=true"
import script from "./ZhangGH.vue?vue&type=script&lang=js"
export * from "./ZhangGH.vue?vue&type=script&lang=js"

import "./ZhangGH.vue?vue&type=style&index=0&id=1e908c89&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e908c89"]])

export default __exports__